import { Box } from '@gemini/core';
import { useAppContext } from '@mfe-presentation/contexts';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const LegalText = () => {
    const { t } = useTranslation(NAME_SPACE);
    const { control } = useFormContext();
    const {
        currentStep: { name },
    } = useAppContext();
    const isAPrivatePerson = useWatch({ control, name: 'isAPrivatePerson' });

    if (!isAPrivatePerson) {
        return null;
    }
    return (
        <Box as="p" typography="typography.body.14.regular">
            {t(`step_${name}.legalText`)}
        </Box>
    );
};

export default LegalText;
